import { Box, Typography } from '@mui/material'
import {
    AlignType, HeaderType
} from 'src/components/UI/CustomUI/organisms/Table/types'

const headers: HeaderType[] = [
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'address',
    label: 'Office Address',
    custom: true,
    align: 'left' as AlignType,
    Element: (row: any): JSX.Element => {
      return (
        <Box padding="2px 10px">
          <Typography>{row?.address?.fullAddress}</Typography>
        </Box>
      )
    },
  },
]

export default headers
